export const BASE_URL = "https://rolling-api.vercel.app/2-1";

export const DEVICE_MAX_SIZE = {
  MOBILE: 425,
  TABLET: 768,
  NOTEBOOK: 1024,
  PC: 1248,
};

export const ITEMS_PER_PAGE = {
  PC: 4,
  NOTEBOOK: 3,
  TABLET: 2,
  MOBILE: 1,
};
export const CARD_WIDTH = 29.5;
export const SWIPE_X = 50;

export const LIST_TITLE = ["검색 결과 🔍", "인기 롤링 페이퍼 🔥", "최근에 만든 롤링 페이퍼 ⭐️"];

export const WARNING_MESSAGE = {
  POST_CARD: "받는 사람을 입력해 주세요.(최대 8자까지 입력 가능합니다.)",
  POST_MESSAGE: "이름을 입력해 주세요.(최대 8자까지 입력 가능합니다.)",
  EMPTY_VALUE: "값을 입력해 주세요.",
  MAX_VALUE: "최대 8글자까지 입력이 가능합니다.",
};
